<template>
  <div class="md-layout page-offering">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Offering") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Flight Review General Settings") }}</h4>
          </div>
        </md-card-header>
        <md-card-content class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-90">
            <validated-dropdown-input
              :options="schools"
              v-model="reviewSettings.flight_schools"
              :label="
                $t(
                  'Flight School(s) - Choose the flight school(s) you are affiliated with'
                )
              "
              name="flightschool"
              validation-rules="required"
              :disabled="generalSettingStatus === 'detail'"
              :multiselect="true"
              :valueTransformation="item => item.FlightSchoolName"
              :displayTransformation="item => item.FlightSchoolName"
            />
          </div>
          
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-button
              v-if="generalSettingStatus === 'edit'"
              class="md-raised mt-4 mr-10"
              @click="cancelReviewSetting"
            >
              {{ $t("Cancel") }}
            </md-button>

            <md-button
              :disabled="btnLoading"
              class="md-raised md-primary mt-4"
              @click="updateReviewsettings"
            >
              {{
                generalSettingStatus === "detail"
                  ? $t("Edit Settings")
                  : generalSettingStatus === "edit"
                  ? $t("Update Settings")
                  : $t("Save Settings")
              }}
            </md-button>
          </div>
        </md-card-content>
      </md-card>

      <md-card style="margin-top: 60px">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Flight Review Address") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="address-wrapper">
            <div v-if="addressList.length<3" class="address-block address-add" @click="() => {
              showAddressPop=true
            }">
              <md-icon class="md-size-3x" style="color: #c7c7c7;">add</md-icon>
              <h2>Add Address</h2>
            </div>
            <div v-for="item in addressList" :key="item._id.$oid" class="address-block address-detail">
              <div class="type">Type: {{ addressTypeMap[item.address_customized] }}</div>
              <div class="content">
                <div class="title" v-if="item.club_name">Club Name: {{ item.club_name }}</div>
                <div v-if="item.review_street">{{ item.review_street }}</div>
                <div v-if="item.review_street_desc">{{ item.review_street_desc }}</div>
                <div>{{ item.review_city }}, {{ item.review_province }} {{ item.review_postalcode }}</div>
                <br/>
                <div v-if="item.latitude && item.longitude">
                  GPS Coordinates: {{ `${item.latitude.toFixed(6)}, ${item.longitude.toFixed(6)}` }}
                  </div>
                <div>Review timezone: {{ item.review_timezone }}</div>
                <div class="link-wrapper">
                  <a href="javascript:void(0)" @click="editAddress(item)">Edit</a>
                  <span class="split"></span>
                  <a href="javascript:void(0)" @click="removeAddress(item)">Remove</a>
                </div>
              </div>
            </div>
          </div>
          
        </md-card-content>
      </md-card>

      <md-card style="margin-top: 60px">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("Flight Review Offering") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div>
            <md-checkbox v-model="reviewPackage.enable" :disabled="offeringStatus === 'detail'">{{
          $t("Flight Review")
              }}</md-checkbox>
          </div>
          <div v-if="reviewPackage.enable">
            <validated-text-input :label="$t('Flight Review Price ($)')" name="Flight Review Price"
              v-model="reviewPackage.price" :validation-rules="reviewPackage.enable ? `required|between:${reviewerPriceMin},${reviewerPriceMax}` : ''
          " type="number" :disabled="offeringStatus === 'detail'" />
          </div>

          <div>
            <md-checkbox v-model="trainingPackage.enable" :disabled="offeringStatus === 'detail'">{{
          $t("Flight Training")
              }}</md-checkbox>
          </div>
          <div v-if="trainingPackage.enable">
            <validated-text-input :label="$t('Flight Training Price ($)')" name="Flight Training Price"
              v-model="trainingPackage.price" :validation-rules="trainingPackage.enable ? `required|between:${reviewerPriceMin},${reviewerPriceMax}` : ''
          " type="number" :disabled="offeringStatus === 'detail'" />
          </div>
          
          <div class="md-layout-item md-size-60">
            <div v-show="offeringStatus !== 'detail' && (reviewPackage.enable || trainingPackage.enable)">
              <md-checkbox v-model="tncAim" @change="changeState">{{
                $t("I agree to")
              }}</md-checkbox>
              <a
                style="margin-left: -20px; vertical-align: super;"
                href="/#/reviewerTnc"
                target="_blank"
                >{{
                  $t(
                    "RPAS WILCO Terms and Conditions for Flight Reviewers"
                  )
                }}</a
              >
            </div>
            <div
              v-if="showError"
              class="md-layout-item md-size-100 text-danger"
            >
              {{ $t("You need to accept Terms & Conditions to continue.") }}
            </div>
          </div>
          <div>
            <md-button
              v-if="offeringStatus === 'edit'"
              class="md-raised mt-4 mr-10"
              @click="offeringStatus = 'detail'"
            >
              {{ $t("Cancel") }}
            </md-button>

            <md-button
              :disabled="errors.any() || btnLoading"
              class="md-raised md-primary mt-4"
              @click="updatePrice"
            >
              {{
                offeringStatus === "detail"
                  ? this.$t("Edit offering")
                  : this.$t("Update offering")
              }}
            </md-button>
          </div>
        </md-card-content>
      </md-card>
      <AddressPop v-if="showAddressPop"
        :visiable="true" 
        :reviewAddressDefault="reviewAddress"
        :onclose="() => {
          reviewAddress = {}
          showAddressPop = false
        }"
        :onsave="saveAddressCbfn"
      />
    </div>
  </div>
</template>

<script>
import "vue2-timepicker/dist/VueTimepicker.css";
import {
  getMyPackageList,
  addPackage,
  updatePackage,
  getFlightSchool,
  generalSetting,
  getAddressList,
  deleteAddress
} from "@/services/flightReview.service.js";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInputBrief.vue";
import ValidatedAutocompleteInput from "@/components/Inputs/ValidatedAutocompleteInput.vue";
import ValidatedDropdownInput from "@/components/Inputs/ValidatedDropdownInputBrief.vue";
import AddressPop from "./bricks/AddressPop.vue";
import {
  REVIEWER_PRICE_MIN,
  REVIEWER_PRICE_MAX,
  CanadaTimezones,
  FLIGHT_REVIEW_ADDRESS,
  FLIGHT_REVIEW_PACKAGE_TYPE
} from "@/const.js";
import { mapFields } from "vuex-map-fields";
import { EventBus } from "@/helpers";
import swal from "sweetalert2";

export default {
  provide() {
    return {
      $validator: this.$validator
    };
  },
  $_veeValidate: {
    validator: "new"
  },
  components: {
    ValidatedTextInput,
    ValidatedAutocompleteInput,
    ValidatedDropdownInput,
    AddressPop
  },
  data() {
    return {
      reviewerPriceMin: REVIEWER_PRICE_MIN,
      reviewerPriceMax: REVIEWER_PRICE_MAX,
      offeringStatus: "edit", // types: detail | edit
      generalSettingStatus: "detail",
      btnLoading: false,
      reviewPackage: {
        package_type: FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW,
        title: "",
        package_desc: "",
        enable: false,
        price: "",
      },
      trainingPackage: {
        package_type: FLIGHT_REVIEW_PACKAGE_TYPE.TRAINING,
        title: "",
        package_desc: "",
        enable: false,
        price: "",
      },
      tncAim: false,
      showError: false,
      schools: [],
      reviewSettings: {
        flight_schools: []
      },
      showAddressPop: false,
      addressList: [],
      addressTypeMap: {
        [FLIGHT_REVIEW_ADDRESS.ADDRESS_AUTO]: this.$t("Address"),
        [FLIGHT_REVIEW_ADDRESS.ADDRESS_CUSTOMIZED]: this.$t("GPS Coordinates"),
        [FLIGHT_REVIEW_ADDRESS.ADDRESS_CLUB]: "MAAC Club",
      },
      reviewAddress: {},
    };
  },
  async mounted() {
    this.loadReviewPackage();
    this.loadFlightSchool();
    this.initReviewerSettings();
    this.getAddressList()

    EventBus.$on("getUserProfile", userInfo => {
      if (userInfo.review_postalcode) {
        this.initReviewerSettings();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("getUserProfile");
  },
  methods: {
    async loadReviewPackage() {
      const myPackageList = await getMyPackageList();
      if (!myPackageList.length) return
      this.offeringStatus = "detail";
      myPackageList.forEach(item => {
        if (item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW) {
          this.reviewPackage.id = item._id.$oid;
          this.reviewPackage.title = item.title;
          this.reviewPackage.enable = item.enable === 1 ? true : false
          this.reviewPackage.price = (+item.price / 100).toFixed(2);
        } else if (item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.TRAINING) {
          this.trainingPackage.id = item._id.$oid;
          this.trainingPackage.title = item.title;
          this.trainingPackage.enable = item.enable === 1 ? true : false
          this.trainingPackage.price = (+item.price / 100).toFixed(2);
        }
      })
    },
    async loadFlightSchool() {
      this.schools = await getFlightSchool();
    },
    
    updateReviewsettings() {
      switch (this.generalSettingStatus) {
        case "add":
        case "edit":
          this.$validator.validateAll().then(res => {
            if (res) {
              this.btnLoading = true;
              const {
                flight_schools
              } = this.reviewSettings;
              generalSetting({
                flight_schools
              })
                .then(() => {
                  this.$notify({
                    message: this.$t(
                      "Update flight review general settings successful"
                    ),
                    horizontalAlign: "center",
                    verticalAlign: "top",
                    type: "success",
                    timeout: 3000
                  });
                  this.generalSettingStatus = "detail";
                  this.$store.dispatch("auth/getUserProfile");
                })
                .finally(() => {
                  this.btnLoading = false;
                });
            }
          });
          break;

        case "detail":
          this.generalSettingStatus = "edit";
          break;
      }
    },
    cancelReviewSetting() {
      this.generalSettingStatus = "detail";
      this.initReviewerSettings();
    },
    initReviewerSettings(addressobj = this.$store.state.auth) {
      Object.keys(this.reviewSettings).forEach(key => {
        this.reviewSettings[key] = addressobj[key] || "";
      });
      if (this.reviewSettings.flight_schools.length === 0) {
        this.generalSettingStatus = "add";
      } else {
        this.generalSettingStatus = "detail";
      }
      this.reviewSettings = { ...this.reviewSettings };
    },
    updatePrice() {
      switch (this.offeringStatus) {
        case "edit":
          this.$validator.validateAll().then(res => {
            if (res) {
              if (!this.tncAim && (this.reviewPackage.enable || this.trainingPackage.enable)) {
                this.showError = true;
                return;
              }
              // review
              if (this.reviewPackage.enable) {
                if (
                  +this.reviewPackage.price < REVIEWER_PRICE_MIN ||
                  +this.reviewPackage.price > REVIEWER_PRICE_MAX
                ) {
                  return;
                }
              }
              let reviewUrl = addPackage
              if (this.reviewPackage.id) {
                reviewUrl = updatePackage
              }

              // training
              if (this.trainingPackage.enable) {
                if (
                  +this.trainingPackage.price < REVIEWER_PRICE_MIN ||
                  +this.trainingPackage.price > REVIEWER_PRICE_MAX
                ) {
                  return;
                }
              }
              let trainingUrl = addPackage
              if (this.trainingPackage.id) {
                trainingUrl = updatePackage
              }

              this.btnLoading = true;
              Promise.all([reviewUrl(this.reviewPackage), trainingUrl(this.trainingPackage)])
                .then(() => {
                  this.loadReviewPackage()
                  this.$notify({
                    message: this.$t("Package update successful"),
                    horizontalAlign: "center",
                    verticalAlign: "top",
                    type: "success",
                    timeout: 3000
                  });
                  this.offeringStatus = "detail";
                })
                .finally(() => {
                  this.btnLoading = false;
                });
            }
          })
      
          break;

        case "detail":
          this.offeringStatus = "edit";
          break;
      }
    },
    changeState() {
      if (this.tncAim) {
        this.showError = false;
      }
    },
    async getAddressList() {
      const addressList = await getAddressList()
      this.addressList = addressList
    },
    saveAddressCbfn() {
      this.getAddressList()
      this.reviewAddress = {}
      this.showAddressPop = false
    },
    removeAddress(item){
      const _self = this
      swal
      .fire({
        text: _self.$t(
          "Are you sure you want to delete it?"
        ),
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: _self.$t("Yes"),
        cancelButtonText: _self.$t("Cancel"),
        buttonsStyling: false
      })
      .then(({ value }) => {
        if (!value) {
          return;
        }
        deleteAddress(item._id.$oid).then(() => {
          this.getAddressList()
          this.$notify({
            message: this.$t("Update flight review address successful"),
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success",
            timeout: 3000
          });
        })
      });
    },
    editAddress(item) {
      this.reviewAddress = item
      this.showAddressPop = true
    }
  }
};
</script>

<style lang="css">
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.mt-10 {
  margin-top: 10px;
}

.page-offering {
  .md-checkbox {
    z-index: 0;
  }

  .vue__time-picker .dropdown ul li:not([disabled]).active {
    background: #0abab5;
  }

  .md-disabled .md-checkbox-label,
  .md-disabled .md-checkbox-container,
  .md-checked.md-disabled .md-checkbox-container,
  .md-radio.md-disabled .md-radio-label,
  .md-radio.md-disabled .md-radio-container {
    opacity: 1;
    cursor: not-allowed;
  }
  .vue__time-picker input.display-time.disabled,
  .vue__time-picker input.display-time:disabled {
    color: #000;
  }

  .address-wrapper {
    padding: 24px 0;
    display: flex;
    flex-wrap: wrap;
  }
  .address-block {
    height: 266px;
    width: 320px;
    margin: 12px;
    border-radius: 4px;
    border: 1px solid #C7C7C7;
    box-sizing: border-box;
    position: relative;
  }
  .address-add {
    padding-top: 40px;
    border-style: dashed;
    border-width: 2px;
    color: #565959;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
  }
  .address-detail {
    color: #0f1111;
    .type {
      border-bottom: 1px solid #C7C7C7;
      padding: 12px 20px;
      color: #565959;
    }
    .title {
      color: #0f1111;
    }
    .content {
      padding: 12px 20px;
    }
    .link-wrapper {
      position: absolute;
      bottom: 20px;
      left: 12px;
      display: flex;
      align-items: center;
      a {
        display: inline-block;
        padding: 0 12px;
      }
      .split {
        width: 1px;
        height: 10px;
        background-color: #565959;
      }
    }
  }
}
</style>
